import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const MaturityRadar = ({ vm }) => {
  const data = {
    labels: vm.eixos.map(e => e.rotulo),
    datasets: [
      {
        label: 'Maturidade',
        data: vm.eixos.map(e => e.notaRadar),
        backgroundColor: 'rgba(99, 102, 241, 0.2)',
        borderColor: 'rgba(99, 102, 241, 1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(99, 102, 241, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(99, 102, 241, 1)'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.label}: ${context.parsed.r.toFixed(1).replace('.', ',')}/6,0`;
          }
        }
      }
    },
    scales: {
      r: {
        angleLines: {
          display: true,
          color: '#e2e8f0'
        },
        grid: {
          color: '#e2e8f0'
        },
        pointLabels: {
          font: {
            size: 11
          },
          color: '#64748b'
        },
        suggestedMin: 0,
        suggestedMax: 6,
        ticks: {
          stepSize: 1,
          callback: function(value) {
            return value.toFixed(0);
          }
        }
      }
    }
  };

  const containerStyle = {
    marginBottom: '32px',
    padding: '24px',
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
  };

  const titleStyle = {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: '20px'
  };

  const chartContainerStyle = {
    height: '350px',
    marginBottom: '24px'
  };

  return (
    <section style={containerStyle} aria-label="Radar de Maturidade">
      <h3 style={titleStyle} title="Cada eixo = (resposta-1)*(6/5). Escala 0-6">
        Radar de Maturidade (0-6)
      </h3>
      <div style={chartContainerStyle}>
        <Radar data={data} options={options} />
      </div>
    </section>
  );
};

export default MaturityRadar;